export default "__VITE_ASSET__a902939b__"